import React, { useState, useMemo, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { API_URL } from "../config/api";

const projectsStatic = [
  { id: 1, image: "/assets/hamesha.jpeg", title: "Hamesha", year: 1997, director: "Sanjay Gupta", producer: "G. P. Sippy", cast: "Saif Ali Khan, Kajol, Aditya Pancholi", music: "Anu Malik" },
  { id: 2, image: "/assets/aatish.jpeg", title: "Aatish", year: 1994, director: "Sanjay Gupta", producer: "G. P. Sippy", cast: "Sanjay Dutt, Karishma Kapoor, Aditya Pancholi, Raveena Tandon", music: "Nadeem - Shravan" },
  { id: 3, image: "/assets/adle.jpeg", title: "Adi-E-Jehangir", year: 1955, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Pradeep Kumar, Meena Kumari, Sapru", music: "Husanlal Bhagatram" },
  { id: 4, image: "/assets/AHSAAS-Tosend.jpg", title: "Ahsaas", year: 1979, director: "Surendra Suri", producer: "G. P. Sippy", cast: "Dina Parvez, Shashi Kapoor (Sp. App.), Shammi Kapoor, Simmi, Amjad Khan", music: "Bhappi Lahari" },
  { id: 5, image: "/assets/andaz.jpeg", title: "Andaaz", year: 1971, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Shammi Kapoor, Rajesh Khanna, Hema Malini, Simmi", music: "Shankar - Jaikishan" },
  { id: 6, image: "/assets/bandhan.jpeg", title: "Bandhan", year: 1970, director: "Narinder Bedi", producer: "G. P. Sippy", cast: "Mumtaz, Rajesh Khanna, Anju Mahendru, Kanhaiyalal", music: "Kalyanji-Anandji" },
  { id: 7, image: "/assets/Bewaqoof_Finaltosend.jpg", title: "Bewaqoof", year: 1960, director: "I. S. Johar", producer: "G. P. Sippy", cast: "Kishore Kumar, Mala Sinha, Pran, I.S. Johar", music: "S. D. Burman" },
  { id: 8, image: "/assets/Bhai-Bahen.jpg", title: "Bhai Bahen", year: 1959, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Daisy Irani, Baby Naaz, Nishi, Rehman, Jhonny Walker", music: "N. Dutta" },
  { id: 9, image: "/assets/bhrashtachar.jpeg", title: "Bhrashtachar", year: 1989, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Rekha, Mithun Chakravorty, Anupam Kher, Raza Murad, Shilpa Shirodkar (Intro.)", music: "Laxmikant Pyarelal" },
  { id: 10, image: "/assets/BRAHMACHARI-Tosend.jpg", title: "Brahmachari", year: 1968, director: "Bhappi Sonie", producer: "G. P. Sippy", cast: "Shammi Kapoor, Rajshri, Pran, Junior Mehmood", music: "Shankar - Jaikishan" },
  { id: 11, image: "/assets/Chandrakanta Filetosend.jpg", title: "Chandrakanta", year: 1956, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Beena Roy", music: "N. Dutta" },
  { id: 12, image: "/assets/clock.jpeg", title: "12 'Clock", year: 1958, director: "Pramod Chakraborty", producer: "G. P. Sippy", cast: "Guru Dutt, Waheeda Rehman, Jhonny Walker", music: "O.P. Nayyar" },
  { id: 13, image: "/assets/Johar-mehmood-in-Goa.jpg", title: "Johar Mehmood in Goa", year: 1965, director: "I. S. Johar", producer: "G. P. Sippy", cast: "Mehmood, I.S. Johar, Simmi, Sonia Sahani", music: "Kalyanji-Anandji" },
  { id: 14, image: "/assets/Johar in Kashmir Finaltosend .jpg", title: "Johar In Kashmir", year: 1966, director: "I. S. Johar", producer: "G. P. Sippy", cast: "I.S. Johar, Sonia Sahani", music: "Kalyanji-Anandji" },
  { id: 15, image: "/assets/Light House.jpg", title: "Light House", year: 1958, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Ashok Kumar, Nutan, Jhonny Walker", music: "N. Dutta" },
  { id: 16, image: "/assets/Marine_Drive-Tosend.jpg", title: "Marine Drive", year: 1955, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Ajit, Beena Roy, K. N. Singh", music: "N. Dutta" },
  { id: 17, image: "/assets/meresanam.jpeg", title: "Mere Sanam", year: 1965, director: "Amar Kumar", producer: "G. P. Sippy", cast: "Asha Parekh, Biswajeet, Pran, Rajendra Nath", music: "O. P. Nayyar" },
  { id: 18, image: "/assets/Mr. India.jpg", title: "Mr. India", year: 1961, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "I.S. Johar, Geeta Bali", music: "N.S. Kohli" },
  { id: 19, image: "/assets/sholay.jpeg", title: "Sholay: The Final Cut", year: 2025, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Sanjeev Kumar, Dharmendra, Amitabh Bachchan, Hema Malini, Jaya Baduri, Amjad Khan", music: "R. D. Burman" },
  { id: 20, image: "/assets/Nasbandi.jpg", title: "Nasbandi", year: 1978, director: "I.S. Johar", producer: "G. P. Sippy", cast: "I.S. Johar, Rajendra Nath, Ambika Johar", music: "Kalyanji-Anandji" },
  { id: 21, image: "/assets/patrhar.jpeg", title: "Patthar Ke Phool", year: 1991, director: "Anant Balani", producer: "G. P. Sippy", cast: "Salman Khan, Raveena Tandon, Kiran Kumar", music: "Ram - Laxman" },
  { id: 22, image: "/assets/RAAZ.jpg", title: "Raaz", year: 1967, director: "Ravindra Dave", producer: "G. P. Sippy", cast: "Rajesh Khanna, Babita, I. S. Johar, Laxmi Chhaya", music: "Kalyanji-Anandji" },
  { id: 23, image: "/assets/Radha Krishna.jpg", title: "Radha Krishna ", year: 1954, director: "Raja Naine", producer: "G. P. Sippy", cast: "Kamini Kaushal, Ratan, Agha, Jhonny Walker", music: "S. D. Burman" },
  { id: 24, image: "/assets/rajugentle.jpeg", title: "Raju Ban Gaya Gentleman", year: 1992, director: "Aziz Mirza", producer: "G. P. Sippy", cast: "Shah Rukh Khan, Juhi Chawla, Amrita Singh, Nana Patekar", music: "Jatin - Lalit" },
  { id: 25, image: "/assets/saagar.jpeg", title: "Saagar", year: 1985, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Rishi Kapoor, Kamal Hassan, Dimple Kapadia", music: "R. D. Burman" },
  { id: 26, image: "/assets/Sazaa-Tosend.jpg", title: "Sazaa", year: 1952, director: "Fali Mistry", producer: "G. P. Sippy", cast: "Dev Anand, Nimmi, Shyama", music: "S. D. Burman" },
  { id: 27, image: "/assets/Seeta Aur Geeta.jpg", title: "Seeta Aur Geeta", year: 1972, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Dharmendra, Hema Malini, Sanjeev Kumar", music: "R. D. Burman" },
  { id: 28, image: "/assets/shanman.jpeg", title: "Shaan", year: 1980, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Amitabh Bachchan, Shashi Kapoor, Shatrughan Sinha, Rakhee, Sunil Dutt", music: "R. D. Burman" },
  { id: 29, image: "/assets/sholay.jpeg", title: "Sholay", year: 1975, director: "Ramesh Sippy", producer: "G. P. Sippy", cast: "Sanjeev Kumar, Dharmendra, Amitabh Bachchan, Hema Malini, Jaya Baduri, Amjad Khan", music: "R. D. Burman" },
  { id: 30, image: "/assets/Shrimati-420-30x40-jpeg.jpg", title: "Shrimati 420", year: 1956, director: "G. P. Sippy", producer: "G. P. Sippy", cast: "Meena Shorey, Om Prakash, Jhonny Walker", music: "N. Dutta" },
  { id: 31, image: "/assets/Trishna-Tosend.jpg", title: "Trishna", year: 1978, director: "Anil Ganguly", producer: "G. P. Sippy", cast: "Shashi Kapoor, Rakhee Gulzar, Sanjeev Kumar, Bindu", music: "Kalyanji-Anandji" },
  { id: 32, image: "/assets/Shahenshah.jpg", title: "Shehenshah", year: 1953, director: "Amiya Chakraborty", producer: "G. P. Sippy", cast: "Ranjan, Kamini Kaushal", music: "S. D. Burman" },
  { id: 33, image: "/assets/trishna.jpeg", title: "Mr. X", year: 1957, director: "Nanabhai Bhatt", producer: "G. P. Sippy", cast: "Ashok Kumar, Nalini Jaywant, Jhonny Walker, Pran", music: "N. Dutta" },
  { id: 34, image: "/assets/BLACK CAT-Tosend.jpg", title: "Black Cat", year: 1959, director: "N. A. Ansari", producer: "G. P. Sippy", cast: "Balraj Sahani, Meenu Mumtaz, N. A. Ansari, Jhonny Walker", music: "N. Dutta" },
  
];

export default function ProjectGrid() {
  const [projects, setProjects] = useState(projectsStatic);
  const [loading, setLoading] = useState(true);
  const [activeFilmId, setActiveFilmId] = useState(null);
  // Default on every load/refresh: newest first (year, descending)
  const [sortBy, setSortBy] = useState("year");
  const [sortDirection, setSortDirection] = useState("desc");


  useEffect(() => {
    fetch(`${API_URL}/api/films`)
      .then(res => res.json())
      .then(data => {
        setProjects(prev => {
          const existingIds = new Set(prev.map(p => p._id || p.id));
          const newData = data.filter(d => !existingIds.has(d._id || d.id));
          return [...prev, ...newData];
        });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Toggle year sort (starts at newest first when switching from A-Z)
  const toggleYearSort = () => {
    if (sortBy !== "year") {
      setSortBy("year");
      setSortDirection("desc");
    } else {
      setSortDirection((prev) => (prev === "desc" ? "asc" : "desc"));
    }
  };

  /* Alphabetical sort hidden
  // Toggle alpha sort (starts at A-Z when switching from year)
  const toggleAlphaSort = () => {
    if (sortBy !== "alpha") {
      setSortBy("alpha");
      setSortDirection("asc");
    } else {
      setSortDirection((prev) => (prev === "desc" ? "asc" : "desc"));
    }
  };
  */

  // Sort films
  const filteredProjects = useMemo(() => {
    const filtered = [...projects];

    return filtered.sort((a, b) => {
      if (sortBy === "year") {
        // Number() keeps string years from the API sorting correctly;
        // same-year films fall back to title so the order stays stable.
        const diff = Number(a.year) - Number(b.year);
        return (sortDirection === "desc" ? -diff : diff) || a.title.localeCompare(b.title);
      }
      // asc = A-Z, desc = Z-A
      return sortDirection === "asc"
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title);
    });
  }, [projects, sortBy, sortDirection]);

  return (
    <section className="projects-container">
      {/* Films heading and sorting controls */}
      <div className="search-wrapper">
        <h2 className="section-title">
          Films
        </h2>
        
        <div className="controls-row">
          {/* Sort by Year */}
          <button 
            className={`sort-button ${sortBy === "year" ? "active" : ""}`} 
            onClick={toggleYearSort}
          >
            <svg
              className={`sort-icon ${sortDirection === "desc" ? "flipped" : ""}`}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 5v14M5 12l7-7 7 7" />
            </svg>
            <span className="sort-label">
              {sortDirection === "desc" ? "Newest": "Oldest" }
            </span>
          </button>

          {/* Sort Alphabetically — hidden
          <button 
            className={`sort-button ${sortBy === "alpha" ? "active" : ""}`} 
            onClick={toggleAlphaSort}
          >
            <svg
              className={`sort-icon ${sortDirection === "asc" ? "flipped" : ""}`}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 6h18M3 12h12M3 18h6" />
            </svg>
            <span className="sort-label">
              {sortDirection === "desc" ? "Z-A" : "A-Z"}
            </span>
          </button>
          */}
        </div>
        
        <p className="results-count">
          Showing {filteredProjects.length} films • {sortBy === "year" 
            ? (sortDirection === "desc" ? "Newest First" : "Oldest First") 
            : (sortDirection === "desc" ?  "Z-A": "A-Z")}
        </p>
      </div>

      {/* Streamlined Grid */}
<motion.div layout className="streamlined-grid">
        <AnimatePresence mode="popLayout">
          {!loading && filteredProjects.map((item) => (
            <motion.div
              key={item._id || item.id}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.4 }}
              className={`film-card ${activeFilmId === (item._id || item.id) ? "active" : ""}`}
              onClick={() => {
                if (window.matchMedia("(hover: none)").matches) {
                  const filmId = item._id || item.id;
                  setActiveFilmId((currentId) => currentId === filmId ? null : filmId);
                }
              }}
            >
              <div className="image-box">
      <img
  src={
    item.image && item.image !== "null"
      ? item.image
      : "/assets/sholay.jpeg"
  }
  alt={item.title}
  loading="lazy"
  decoding="async"
  onError={(e) => { e.target.src = "/assets/sholay.jpeg"; }}
/>
                <div className="hover-details">
                  <p><span>DIRECTOR</span> {item.director}</p>
                  <p><span>MUSIC</span> {item.music}</p>
                  <p><span>CAST</span> {item.cast}</p>
                </div>
              </div>

              <div className="film-info">
                 <h3 className="film-title">{item.title}</h3>
                <p className="release-year">{item.year}</p>
             
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>

      <style>{`
        .projects-container {
          background: #000;
          color: #fff;
          padding: 120px 5%;
          min-height: 100vh;
        }

        .search-wrapper {
          max-width: 1400px;
          margin: 0 auto 60px;
          text-align: left;
    
        }

        .section-title {
          font-size: 4rem;
          text-transform: uppercase;
          letter-spacing: -1px;
          margin-bottom: 30px;
        }

        .gold-dot {
          color: #c5a059;
        }

        .controls-row {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 15px;
          flex-wrap: wrap;
        }

        /* Sort Button Styles */
        .sort-button {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #111;
          border: 1px solid #333;
          padding: 16px 24px;
          border-radius: 50px;
          color: #fff;
          font-size: 0.85rem;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .sort-button:hover {
          border-color: #ffffff;
          background: #1a1a1a;
        }

        .sort-button.active {
          border-color: #26b8eb;
          background: #1a1a1a;
        }

        .sort-icon {
          color: #26b8eb;
          transition: transform 0.3s ease;
        }

        .sort-icon.flipped {
          transform: rotate(180deg);
        }

        .sort-label {
          font-weight: 500;
        }

        .results-count {
          margin-top: 20px;
          font-size: 0.8rem;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 1px;
          text-align: left;
        }

        .streamlined-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
          gap: 40px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .film-card {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .image-box {
          position: relative;
          aspect-ratio: 2 / 3;
          border-radius: 4px;
          overflow: hidden;
          background: #111;
        }

        .image-box img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hover-details {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          flex-direction: column;


          
          justify-content: center;
          padding: 20px;
          opacity: 0;
          transition: opacity 0.3s ease;
          font-size: 1.1rem;
          line-height: 1.4;
        }

        .hover-details p span {
          color:#26b8eb; 
          font-weight: bold;
          display: block;
            
          font-size: 0.85rem;
        }

        @media (hover: hover) and (pointer: fine) {
          .image-box:hover .hover-details {
            opacity: 1;
          }
        }

        @media (hover: none) {
          .film-card.active .hover-details {
            opacity: 1;
          }
        }

        .film-info {
          padding: 5px 0;
        }

        .release-year {
          color:  #26b8eb; 
          font-weight: 700;
          font-size: 0.9rem;
          margin: 0;
        }

        .film-title {
          font-size: 1.4rem;
          margin: 5px 0 0;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 500;
        }

        @media (max-width: 600px) {
          .controls-row {
            flex-direction: column;
            align-items: flex-start;
          }
          .section-title{
            font-size: 2.5rem;
            }
          .sort-button {
            width: 100%;
            max-width: 500px;
            justify-content: center;
          }

          .streamlined-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .film-title {
            font-size: 1rem;
          }
            .results-count{
            width: 100%;
            text-align: left;
            }

          .hover-details {
            font-size: 0.7rem;
            line-height: 1.3;
            padding: 10px;
            justify-content: flex-end;
            background: linear-gradient(to top, rgba(0,0,0,0.92) 60%, transparent 100%);
          }

          .hover-details p {
            margin: 2px 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .hover-details p span {
            font-size: 0.6rem;
          }
        }
      `}</style>
    </section>
  );
}